<section class="">
    <div class="container py-0">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 bg-transparent">
                <li class="breadcrumb-item" routerLinkActive="active"><a class="text-dark"
                        [routerLink]="['/']">Home</a>
                </li>
                <li class="breadcrumb-item" routerLinkActive="active"><a class="text-dark"
                        [routerLink]="['/search']">Search</a></li>
            </ol>
        </nav>
    </div>
</section>

<section class="section section-md h-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-7 col-12">
                <div class="input-group input-group-alternative shadow-lg">
                    <div class="input-group-append">
                        <span class="input-group-text"><i class="material-icons md-24">search</i></span>
                    </div>
                    <input type="text" class="form-control form-control-lg px-2" placeholder="Search Keyword">
                    <div class="input-group-prepend">
                        <button class="btn btn-link btn-icon text-default bg-white" type="button" (click)="reset()">
                            <span class="btn-inner--icon"><i class="material-icons md-24">close</i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>